import { DashboardTitle } from 'components/Dashboard/DashboardTitleContext'
import PageComponent from 'components/Dashboard/PageComponent'
import BiogradResults from './BiogradResults'

const Biograd: PageComponent = () => {
  return (
    <div className="container">
      <DashboardTitle title="Biograd" />

      <BiogradResults />
    </div>
  )
}

Biograd.path = '/biograd'
Biograd.displayName = 'Biograd'

export default Biograd
